import { Button, Group, Loader, Stack, TextInput } from "@mantine/core";
import { useEffect, useMemo, useState } from "react";
import { getFolders } from "../../../../../api/FolderAPI";
import {
  IconArrowLeft,
  IconChevronDown,
  IconFolders,
  IconHierarchy2,
  IconSearch,
} from "@tabler/icons-react";
import { Link, useParams } from "react-router-dom";
import { useFolderStore } from "../../../../../stores/FolderStore";
import FolderAdder from "./FolderAdder";
import { useLanguage } from "../../../../../stores/LanguageStore";
import FolderItem from "./FolderItem";
import PopOver from "../../../../../components/View/PopOver";
import { getPools } from "../../../../../api/EmailAPI";
import { useAccountsStore } from "../../../../../stores/ConfigStore";

const FoldersDropdown = ({
  type = "ContactList",
  isPool,
  getClickLink,
  getDeletedLink,
}) => {
  const lang = useLanguage((s) => s.language);
  const { folderId, poolId } = useParams();
  const [loading, setLoading] = useState(true);
  const pools = useAccountsStore((s) =>
    s[type === "Email" ? "email_pools" : "linkedin_pools"].filter(
      (x) => x.type === type
    )
  );
  const folders = useFolderStore((s) =>
    s.folders.filter((x) => x.type === type)
  );

  const items = useMemo(() => {
    return isPool ? pools : folders;
  }, [folders, isPool, pools]);

  const [searchItems, setSearchItems] = useState(items || []);
  const handleInput = (e) => {
    let search = e.target.value;

    let filtered = items.filter((x) => {
      let nameContained = x.name.toLowerCase().includes(search.toLowerCase());

      return nameContained;
    });

    setSearchItems(filtered);
  };

  const handleOpen = () => {
    setSearchItems(items);
    setLoading(true);
    setTimeout(() => {
      document.getElementById("search-folder-input").focus();
    }, 100);
  };

  const onFolderCreated = () => {
    setLoading(true);
    setSearchItems(items);
  };

  useEffect(() => {
    if (loading) {
      if (isPool) {
        getPools()
          .then((r) =>
            setSearchItems(r.data.pools_list.filter((x) => x.type === type))
          )
          .finally(() => setLoading(false));
      } else {
        getFolders()
          .then((r) =>
            setSearchItems(r.data.folders.filter((x) => x.type === type))
          )
          .finally(() => setLoading(false));
      }
    }
  }, [isPool, loading, type]);

  return (
    <Group wrap="nowrap" w={"100%"}>
      <Button
        size="md"
        w={48}
        p={0}
        component={Link}
        to={getDeletedLink()}
        variant="subtle"
      >
        <IconArrowLeft size={24} />
      </Button>

      <PopOver
        opener={(opener, ref) => (
          <Button
            style={{ zIndex: 8 }}
            w={"100%"}
            leftSection={
              loading ? (
                <Loader color="#fff" size={24} />
              ) : isPool ? (
                <IconHierarchy2 size={24} />
              ) : (
                <IconFolders size={24} />
              )
            }
            rightSection={<IconChevronDown />}
            justify="space-between"
            size="md"
            variant="light"
            onClick={(e) => {
              handleOpen();
              opener(e);
            }}
            ref={ref}
          >
            {(folderId && folderId !== "none") || (poolId && poolId !== "none")
              ? items.find((x) => x.id === parseInt(folderId || poolId))?.name
              : lang.prospects.my_folders}
          </Button>
        )}
        popoverChildren={(handleClose) => (
          <Stack gap={0} w={360}>
            <TextInput
              mb={16}
              pos={"relative"}
              id="search-folder-input"
              placeholder={lang.global.search}
              leftSection={<IconSearch size={16} />}
              data-autofocus
              onChange={handleInput}
            />
            <Stack pos={"relative"} mih={300} gap={"xs"}>
              {searchItems.map((folder) => (
                <FolderItem
                  key={folder.id}
                  folder={folder}
                  isPool={isPool}
                  setOpened={() => handleClose(false)}
                  setLoading={setLoading}
                  getClickLink={getClickLink}
                  getDeletedLink={getDeletedLink}
                />
              ))}
              <Group
                pos={"absolute"}
                bottom={0}
                right={0}
                style={{ zIndex: 16 }}
              >
                <FolderAdder
                  type={type}
                  onFinish={onFolderCreated}
                  isPool={isPool}
                />
              </Group>
            </Stack>
          </Stack>
        )}
      />
    </Group>
  );
};

export default FoldersDropdown;
